import { useTranslations } from 'next-intl';
import { useCurrentUser } from 'providers/UserProvider/useCurrentUser';
import { useMembers } from 'providers/UserProvider/useMembers';
import { Option } from 'types/Option';

interface IUseOptionsClientsIn {
  noAny?: boolean;
}
interface IUseOptionsClientsOut {
  optionsClients: Option[];
}

export default function useOptionsClients(
  { noAny }: IUseOptionsClientsIn = { noAny: false }
): IUseOptionsClientsOut {
  const t = useTranslations();

  const { data: members } = useMembers();
  const { data: currentUser } = useCurrentUser();

  const optionsClientsInital = noAny
    ? []
    : [{ label: t('ordering_form.qualities.any'), value: undefined }];

  const optionsClients =
    [
      {
        id: currentUser?.id,
        email: currentUser?.email,
        name:
          currentUser?.firstName && currentUser.lastName
            ? `${currentUser?.firstName} ${currentUser.lastName}`
            : currentUser?.name
      },
      ...(members ?? [])
    ]?.reduce(
      (acc, user) => [
        ...acc,
        {
          label: (user?.name ? user.name : user.email) || t('options.unknown_user'),
          value: user.id
        }
      ],
      optionsClientsInital as Option[]
    ) ?? optionsClientsInital;

  return { optionsClients };
}
